import { call, put, takeLatest } from "redux-saga/effects";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";

import * as actionTypes from "Redux/Actions/actionTypes";
import PlaidListVerificationsRequest from "../../Communication/ApiClasses/PlaidListVerificationsRequest";

// worker
function* handleGetPlaidListVerifications(action) {
  yield put(doLoadingStart(`${actionTypes.GET_PLAID_LIST_VERIFICATIONS}_SAGA`));
  const plaidListVerificationsApi = new PlaidListVerificationsRequest(
    action.clientUserId
  );
  try {
    const result = yield call(plaidListVerificationsApi.getData);
    yield call(action.callback, result);
  } catch (error) {
    yield call(action.callback, error.response);
  } finally {
    yield put(
      doLoadingFinish(`${actionTypes.GET_PLAID_LIST_VERIFICATIONS}_SAGA`)
    );
  }
}

// watcher
export default function* getPlaidListVerificationsWatcherSaga() {
  yield takeLatest(
    actionTypes.GET_PLAID_LIST_VERIFICATIONS,
    handleGetPlaidListVerifications
  );
}
